import { Entity } from '@/modules/common/domain/entity'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
class EntityMap<T extends Entity> {
  [key: string]: T
}

export { EntityMap }
